module.exports = __webpack_public_path__ + "img/PostNl.8920180e.png";